module.exports = __webpack_public_path__ + "static/media/ProfileStep3.fdf91708.svg";